module.exports = __webpack_public_path__ + "static/media/pdf-icon-red-and-white-color-for-free-png.4f2ee2a0.webp";